import { apiClient } from "./client";

export interface MyWorkspace {
  id: string;
  name: string;
  role: "ADMIN" | "USER" | "VIEWER";
  active: boolean;
  estimatedDaysRemaining?: number;
  balanceUsd: number;
  /** Origin this workspace's tracking links are published on: its verified custom domain if it
   * has one, otherwise the shared platform domain. */
  trackingOrigin?: string;
}

export const workspacesApi = {
  getMine: () => apiClient.get<MyWorkspace[]>("/workspaces/mine"),
  switchTo: (workspaceId: string) =>
    apiClient.post<MyWorkspace[]>("/workspaces/switch", { workspaceId }),
};
